<h2 mat-dialog-title>Login</h2>

<form [formRoot]="loginForm">
  <mat-dialog-content>
    <div class="form-field-container">
      <mat-form-field class="full-width" subscriptSizing="dynamic">
        <mat-label>Email</mat-label>
        <input matInput [formField]="loginForm.email" type="email" autocomplete="email" />
        @if (loginForm.email().touched() && loginForm.email().invalid()) {
          <mat-error>
            @for (error of loginForm.email().errors(); track error.kind) {
              <span>{{ error.message }}</span>
            }
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-field-container">
      <mat-form-field class="full-width" subscriptSizing="dynamic">
        <mat-label>Password</mat-label>
        <input
          matInput
          [formField]="loginForm.password"
          type="password"
          autocomplete="current-password"
        />
        @if (loginForm.password().touched() && loginForm.password().invalid()) {
          <mat-error>
            @for (error of loginForm.password().errors(); track error.kind) {
              <span>{{ error.message }}</span>
            }
          </mat-error>
        }
      </mat-form-field>
    </div>

    @if (loginError(); as error) {
      <p class="mb-4 text-sm text-[var(--mat-sys-error)]" role="alert">{{ error }}</p>
    }

    <div class="forgot-password-link">
      <a routerLink="forgotPassword" [mat-dialog-close]="false">I forgot my password</a>
      (Admins or Active Participants Only)
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      matButton="filled"
      type="submit"
      [disabled]="loginForm().invalid() || loginForm().submitting()"
    >
      Login
    </button>
    <button matButton="outlined" type="button" [mat-dialog-close]="false">Cancel</button>
  </mat-dialog-actions>
</form>
